export default __webpack_public_path__ + "static/media/Virgo.0d6d63f1.svg";